module.exports = __webpack_public_path__ + "static/Tiffany.426f8cf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Tiffany.jpg
// module id = 1326
// module chunks = 137408898365125